





































import Vue from 'vue';
// import Analytics from '../../mixins/analytics';
export default Vue.extend({
	name: 'TooltipInfo', 
	props: ['title', 'text', 'small'],
	data(){
		return {
			isOpen: false, 
			conditional: false, 
			arrowLeft: 0
		};
	},
	computed: {
		arrowStyle(): string {
			return this.arrowLeft ? 'left:' + this.arrowLeft + 'px;' : 'left:50%;opacity:0;';
		},
		iconSize(): string {
			return this.small ? '15' : '20';
		}
	},
	methods: {
		positionPopup(): void {
			const divs = (this.$refs.tooltip as any).getContentSlot().filter((o: any) => {
				return o.tag == "div";
			});
			if (!divs || !divs.length || !divs[0].elm) return;
			const popup = divs[0].elm;
			const button = (this.$refs.tooltip as any).getActivator();
			const realButtonLeft = button.getBoundingClientRect().left;
			const realPopupLeft = popup.getBoundingClientRect().left;
			const excess = realButtonLeft - realPopupLeft + 36 - button.offsetWidth / 2;
			this.arrowLeft = excess;
		},
		handleIconClick(): void {
			// Analytics.sendButtonClick(this.title + ' tooltip');
			this.isOpen = !this.isOpen;
			this.conditional = !this.conditional;
			setTimeout(() => {
				this.positionPopup();
			},600);
		},
		handleClickOutside(): void {
			this.isOpen = false;
			this.conditional = false;
		}
	}
});
